module.exports = __webpack_public_path__ + "img/shopNum2.b7abdcf0.jpg";